import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1 className="text-4xl font-bold text-center my-10 mx-4">
        Oops! Page not found
      </h1>
    </div>
  );
};

export default NotFound;
